<template>
  <Tippy
    ref="popover"
    :arrow="true"
    trigger="click"
    interactive
    theme="light"
    placement="bottom"
  >
    <template #trigger>
      <div class="sort-option-selected">
        <div
          class="font-weight-bold text-secondary"
          style="font-size: 10px; min-width: 180px"
        >
          {{ title }}
        </div>

        <div style="font-size: 14px">
          {{ selected.length }} /
          {{ options.length }}
        </div>
      </div>
    </template>

    <div class="dropdown-scroll">
      <div
        v-for="(g, gi) in groups"
        :key="g.name || gi"
      >
        <div
          v-if="g.name"
          class="sort-option group-header text-left d-flex align-items-center"
          :class="{ first: gi === 0 }"
          @click="toggleGroup(g)"
        >
          <Checkbox
            :value="isGroupSelected(g)"
            :emit="false"
            style="margin-left: -0.5rem"
          />
          <div class="flex-grow-1 font-weight-bold">
            {{ g.name }}
          </div>
          <div class="small text-secondary">
            {{ g.options.filter((x) => selected.includes(x.key)).length }} /
            {{ g.options.length }}
          </div>
        </div>
        <div
          v-for="(s, i) in g.options"
          :key="s.key"
          class="sort-option text-left d-flex align-items-center"
          :class="{
            first: !g.name && gi === 0 && i === 0,
            'group-option': !!g.name,
            'font-weight-bold': selected.includes(s.key)
          }"
          @click="toggle(s.key);"
        >
          <Checkbox
            :value="selected.includes(s.key)"
            :emit="false"
            style="margin-left: -0.5rem"
          />
          <div class="flex-grow-1">
            {{ s.text }}
          </div>
        </div>
      </div>
    </div>
  </Tippy>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    selected: Array,
    options: Array,
    title: String,
  },
  data: () => ({
    search: '',
  }),
  computed: {
    ...mapGetters(['payee']),
    groups() {
      return this.options.reduce((acc, curr) => {
        const name = curr.group || null;
        let group = acc.find((x) => x.name === name);
        if (!group) {
          group = { name, options: [] };
          acc.push(group);
        }
        group.options.push(curr);
        return acc;
      }, []);
    },
  },
  methods: {
    isGroupSelected(group) {
      return group.options.every((x) => this.selected.includes(x.key));
    },
    toggleGroup(group) {
      const keys = group.options.map((x) => x.key);
      if (this.isGroupSelected(group)) {
        this.$emit('update:selected', this.selected.filter((x) => !keys.includes(x)));
      } else {
        this.$emit('update:selected', [...new Set([...this.selected, ...keys])]);
      }
    },
    toggle(cid) {
      if (this.selected.includes(cid)) {
        this.$emit('update:selected', this.selected.filter((x) => x !== cid));
      } else {
        this.$emit('update:selected', [...this.selected, cid]);
      }
    },
  },
  created() {
    if (!this.selected || this.selected.length === 0) {
      this.$emit('update:selected', this.options.map((x) => x.key));
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/components/payers/style.scss';

.group-header {
  border-top: 1px solid #eee;
}

.group-option {
  padding-left: 1.5rem;
}
</style>
